import { useQuery } from "@tanstack/react-query"
import { ApplicationKeyValuePairGet } from "../app/models/ApplicationKeyValuePair"
import { Guid } from "../app/models/CustomType"
import { digitalManagerApi } from "../services/api"

export function useApplicationKeyValuePairs(applicationId?: Guid) {
  const {
    data: applicationKeyValuePairs = [],
    isLoading: isLoadingApplicationKeyValuePairs,
  } = useQuery({
    queryKey: ["applicationKeyValuePairs", applicationId],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationKeyValuePairGet[]>(`/applications/${applicationId}/keyValuePairs`)
        .then((r) => r.data),
    enabled: !!applicationId,
  })

  return {
    applicationKeyValuePairs,
    isLoadingApplicationKeyValuePairs,
  }
}
